import { EN_PF_SEARCH_SORT_CODE } from '../enum/EN_PF_SEARCH_SORT_CODE';
import { IAdSectionInfo } from '../interfaces/IAdSectionInfo';
import { ISearchListPlaceItemV7 } from '../interfaces/ISearchListPlaceItem';
import SearchAdvertsQueryParams from '../SearchAdvertsQueryParams';
import SearchListQueryParams from '../SearchListQueryParams';
import { IPolicy } from './IPolicy';

export enum EN_REGION_TYPE {
  ALL = 'ALL',
  MOTEL = 'MOTEL',
  HOTEL = 'HOTEL',
  GUESTHOUSE = 'GUESTHOUSE',
  PENSION = 'PENSION',
}

export enum EN_PLACELIST_TYPE {
  MOTEL = 'motel',
  AROUND_MOTEL = 'around-motel',
  RECOMMEND = 'recommend',
  AROUND = 'around',
  HOTEL = 'hotel',
  GUESTHOUSE = 'guest-house',
  PENSION = 'pension',
  KEYWORD = 'keyword',
  AREA = 'area',
  SEARCH = 'search',
}

/** 지역 및 숏컷 prefix */
export enum EN_PLACELIST_PATH_DIVISION {
  MKEY = 'mkey', // 숏컷 prefix (motel key)
  HKEY = 'hkey', // 숏컷 prefix (hotel key)
  PKEY = 'pkey', // 숏컷 prefix (pension key)
  GKEY = 'gkey', // 숏컷 prefix (guest-house key)
  KEYWORD = 'keyword', // 숏컷 prefix
  REGION = 'r', // 지역 prefix (서브홈 > 지역)
  AREA = 'a', // 지역 prefix (GNB > 지역)
}

export enum EN_EXHIBITION_TYPE {
  MOTEL = 'motel',
  HOTEL = 'hotel',
  PENSION = 'pension',
  GUESTHOUSE = 'guest-house',
  LEISURE = 'leisure',
  GLOBAL_STAY = 'global-stay',
}

export enum EN_CAT_KEY {
  ALL = 'all',
  BARBECUE_PENSION = 'barbecuePension',
  BREAKFAST_GUEST_HOUSE = 'breakfastGuestHouse',
  BREAKFAST_HOTEL = 'breakfastHotel',
  CONSTRUCT = 'construct',
  COUPLE_GUEST_HOUSE = 'coupleGuestHouse',
  FRANCHISE_TYPE = 'franchiseType',
  FREE_MOVIE = 'freeMovie',
  GUEST_HOUSE = 'guestHouse',
  MOTEL = 'motel',
  PARTNERSHIP_TYPE_NOS = 'partnershipTypeNos',
  PARTY_ROOM = 'partyRoom',
  PREMIUM_PENSION = 'premiumPension',
  HOTEL = 'hotel',
  HOT_DEAL = 'hotDeal',
  POOL_HOTEL = 'poolHotel',
  OCEAN_VIEW_HOTEL = 'oceanViewHotel',
  PENSION = 'pension',
  SPA_PENSION = 'spaPension',
  ISOLATE_PENSION = 'isolatePension',
  TOUR_GUEST_HOUSE = 'tourGuestHouse',
  PARTY_GUEST_HOUSE = 'partyGuestHouse',
  RECOMMEND = 'recommend',
  RESORT = 'resort',
  HANOK = 'hanok',
  SEARCH = 'search',
  BOUTIQUE = 'boutique',
  POOLVILLA = 'poolVilla',
}

export enum EN_CELL {
  SMALL_BANNER = 'small_banner',
  TEXT = 'text',
  NONE = 'none',
}

export enum EN_HEADER_CELL {
  TEXT = 'text',
  DOT_LINE = 'not_line',
  BLANK = 'blank',
  NONE = '',
}

export const GroupNameNormal = 'normal';
export const GroupNameError = 'error'; // (!주의) 파트너십 값이 없는 경우
export const GroupNameSorted = 'sorted'; // 기본정렬외 다른 정렬일 경우

export type TGroup = [string, ISearchListPlaceItemV7[]];

export interface IHeader {
  adSlotId?: string;
  index: number;
  title?: string;
  type?: string;
  isBeta?: boolean;
  adTooltip?: {
    available: boolean;
    desc?: string;
  };
}

export interface IGroupSearchList {
  header: IHeader;
  list: ISearchListPlaceItemV7[];
  cellType: EN_CELL;
}

export interface IBuildListParams {
  adSections?: IAdSectionInfo[];
  items?: ISearchListPlaceItemV7[];
  sort?: EN_PF_SEARCH_SORT_CODE;
}

export type TSearchListDefaultParamsType = Partial<SearchListQueryParams | SearchAdvertsQueryParams>;

export interface ISearchListDefaultQueryParamsFunction {
  (query?: TSearchListDefaultParamsType): TSearchListDefaultParamsType;
}

export interface ISearchListPolicyGroupByFunction {
  (item: ISearchListPlaceItemV7): string;
}

export interface ISearchListPolicyGroupHeaderFunction {
  (groupName: string, index: number): IHeader;
}

export interface ISearchListPolicyGroupOrderFunction {
  (group: TGroup): number;
}

export interface ISearchListPolicyGroupFilterFunction {
  (list: ISearchListPlaceItemV7[]): boolean;
}

export interface ISearchListPolicyGroupMappingFunction {
  (group: TGroup, index: number): IGroupSearchList;
}

export interface ISearchListPolicyGroupItemCellTypeFunction {
  (group: TGroup): EN_CELL;
}

export interface ISearchListPolicy {
  // 리스트 빌드 v7
  buildList({ adSections, items, sort }: IBuildListParams): IGroupSearchList[];

  // 정책 데이터
  getPolicy(): IPolicy;

  // 기본 API Request params
  getDefaultQueryParamsFunction(): ISearchListDefaultQueryParamsFunction;

  // 셀 타입
  getGroupItemCellTypeFunction(adSections?: IAdSectionInfo[]): ISearchListPolicyGroupItemCellTypeFunction;

  // 필터링
  getValidGroup(): ISearchListPolicyGroupFilterFunction;

  // 그루핑
  getGroupByFunction(sort?: EN_PF_SEARCH_SORT_CODE): ISearchListPolicyGroupByFunction;

  // 그룹매핑
  getGroupMapping(adSections?: IAdSectionInfo[]): ISearchListPolicyGroupMappingFunction;

  // 그룹 정렬
  getGroupOrderFunction(adSections?: IAdSectionInfo[]): ISearchListPolicyGroupOrderFunction;

  // 그룹 헤더
  getGroupHeaderFunction(adSections?: IAdSectionInfo[]): ISearchListPolicyGroupHeaderFunction;
}
